import { Text } from '@billy/design-system'

import { VatDeclarationsReportField } from '@features/vatDeclarations/types/vatDeclarationsReportField'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { formatAmountWithCurrency } from '../../../../../../../utils/formatAmountWithCurrency'
import { BodyCell } from './styles'

interface TableBodyProps {
  tableRowsData: VatDeclarationsReportField[]
}

export const TableBody = ({ tableRowsData }: TableBodyProps) => {
  const { organization } = useUserOrganization()
  const currency = organization?.baseCurrencyId
  const locale = organization?.localeId

  return (
    <tbody>
      {tableRowsData.map(({ name, symbol, turnoverAmount, vatAmount }: VatDeclarationsReportField) => {
        const amountWithCurrency = vatAmount
          ? formatAmountWithCurrency({
              amount: vatAmount,
              locale,
              currency,
            })
          : 0

        const turnoverAmountWithCurrency = turnoverAmount
          ? formatAmountWithCurrency({
              amount: turnoverAmount,
              locale,
              currency,
            })
          : 0

        return (
          <tr key={`${name}-${symbol}`}>
            <BodyCell>
              <Text>{symbol}</Text>
              <Text>{name}</Text>
            </BodyCell>
            <BodyCell>
              <Text>{turnoverAmountWithCurrency}</Text>
            </BodyCell>
            <BodyCell>
              <Text>{amountWithCurrency}</Text>
            </BodyCell>
          </tr>
        )
      })}
    </tbody>
  )
}
